import {AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {openCloseAnimation} from "../../animations/openCloseAnimation";
import {animate, animation, state, style, transition, trigger, useAnimation} from "@angular/animations";
import {animateShow, slideAnimation} from "../../animations/showHideAnimation";
import {Item} from "../../models/Item";
import {Group} from "../../classes/Groups/Group";
import {DraggableService} from "../../services/draggableService/draggable.service";
import {GroupService} from "../../services/groupService/group-service.service";
import {GroupDomService} from "../../services/groupDOMService/group-dom.service";
import {asyncScheduler, interval, Observable, timer} from "rxjs";
import {debounceTime, filter, throttle, throttleTime} from "rxjs/operators";
import {ItemManagerService} from '../../services/itemManager/item-manager.service';
import {ObjectArrayPlugin} from '../../classes/plugins/objectArrayPlugin/object-array-plugin';
import {isViewMode, isViewModeByShareLink} from '@src/configs/view_only';

@Component({
  selector: 'app-folder-item',
  templateUrl: './item-folder.component.html',
  animations: [animateShow, openCloseAnimation,
    trigger('slideAnimation', [
      transition(':enter', animation([
          style({opacity: '0', width: '0'}),
          animate('300ms ease-out',  style({opacity: '1', width: '*'}))
        ])),
        transition(':leave', animation([
          style({opacity: '1', width: '*'}),
          animate('300ms ease-out',  style({opacity: '0', width: '0'}))
        ])),
    ]),
  ],
  styleUrls: ['./item-folder.component.scss'],
})
export class ItemFolder extends AbstractObserver implements OnInit, AfterViewInit {

  constructor(
    private cd: ChangeDetectorRef,
    private gs: GroupService,
    private gsDOM: GroupDomService,
    private ds: DraggableService,
    private itemManager: ItemManagerService,
  ) {
    super();
  }

  @Input() item: Group;
  @Input() floorPlanChId: string;
  @Input() isFirstLoad: boolean;
  @ViewChild('groupElement', {static: false}) groupElement;
  @ViewChild('inputElement', {static: false}) input;

  public hasChildren = false;
  public hasPrevValue = false;
  public isGrayedOut = false;
  public isMouseOnElement = false;
  public isOpened = false;
  private isAdditionalBlockVisible = false;
  public Yiit = Yiit;
  public currentChildrenList: ConcreteHierarchyItemInterface[] = [];
  public draggableElement = null;
  public isMouseEnter = false;
  private isEventInside = false;
  public isItemsVisible = true;
  public isEmpty = false;
  public isViewOnly = isViewMode || isViewModeByShareLink;

  public ITEM_VISIBILITY_COMPONENT_NAME = 'Folder';

  private openDelayObservable$ = new Observable((observer)=>{
    observer.next(true);
  });

  ngOnInit() {
    this.subscribeToObservable(this.gs.groupItemExpanded$, ((group)=>{
      if (group && group.getId() == this.item.getId()){
        this.isOpened = true;
        this.gs.openedGroups.set(this.item.getId(), this.item);
        this.cd.detectChanges();
      }
    }));
    if (!this.item.is_empty){
        this.gs.fillGroupsWithSubgroups(this.item).then(()=>{
          console.log('subgroups filled');
        });
    }
  }

  ngAfterViewInit(): void {
    if (this.gs.openedGroups.has(this.item.getId())) {
      this.isOpened = true;
    }
    this.subscribeToObservable(this.item.getChildren(), (config) => {
      if (config && config.length) {
        const sortedConfig = config.sort((a, b) => {
          if (a instanceof Group && !(b instanceof Group)) {
            return -1;
          }
          if (!(a instanceof Group) && b instanceof Group) {
            return 1;
          }
          return 0;
        });

        this.currentChildrenList = sortedConfig;


        this.hasChildren = !!(this.currentChildrenList.length);
        this.isEmpty = !this.hasChildren;
        this.item.is_empty = this.isEmpty;
        this.cd.detectChanges();
      }
      else {
        this.currentChildrenList = [];
        this.hasChildren = false;
        this.cd.detectChanges();
      }

      // hide empty groups when init component
      if (!this.item.was_changed) {
        if (!this.hasChildren) {
          this.isEmpty = true;
          this.item.is_empty = this.isEmpty;
          this.cd.detectChanges();
        }
      }
    });

    this.cd.detectChanges();


    this.subscribeToObservable(this.gsDOM.isVisible$, ((value)=>{
      this.isAdditionalBlockVisible = value;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.ds.draggableElement$, ((item:Item)=>{
      this.draggableElement = item;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.ds.onDrop$, (()=>{
      this.ds.draggableElement$ = null;
      this.isMouseEnter = false;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.gs.groupItemTitleFocused$, ((group:Group)=>{
      if (group && group.getId() == this.item.getId()){
        // this.isOpened = true;
        this.input.nativeElement.focus();
        this.cd.detectChanges();
      }
    }));

    this.subscribeToObservable(
        this.gs.onGroupVisibilityUpdated
            .pipe(
                filter(config => config.group.getId() == this.item.getId())
            ),
        (({group, visibility}) => {
          this.isItemsVisible = visibility;
          this.currentChildrenList.forEach((i) => {
            if (i instanceof Item) {
              i.setVisibilityComponent(this.ITEM_VISIBILITY_COMPONENT_NAME, visibility);
              if (!visibility) {
                this.itemManager.checkAndClearSelectedItems(i);
              }
            }
            if (i instanceof Group) {
              this.gs.setGroupItemsVisibility(i, visibility);
            }
          });
          this.cd.detectChanges();
        })
    );

  }


  public get isFastLineEnabled(){
    return this.itemManager.isFastLineSignUp;
  }
  // private updateChildrenList(sortedConfig){
  //   let sortedObj = {};
  //   let currentObj = {};
  //   this.currentChildrenList.forEach((i)=>{
  //     if (i){
  //       currentObj[i.getCHIId()] = i;
  //     }
  //   });
  //   sortedConfig.forEach((i)=>{
  //     if (i){
  //       sortedObj[i.getCHIId()] = i;
  //     }
  //   });
  //
  //   if (this.currentChildrenList.length > sortedConfig.length){
  //       for (let i in currentObj){
  //         if (!sortedObj.hasOwnProperty(i)){
  //           let itemIndex = this.currentChildrenList.indexOf(currentObj[i]);
  //           this.currentChildrenList.splice(itemIndex, 1);
  //         }
  //       }
  //   }
  //
  //   if (this.currentChildrenList.length < sortedConfig.length){
  //     for (let i in sortedObj){
  //       if (!currentObj.hasOwnProperty(i)){
  //         this.currentChildrenList.push(sortedObj[i]);
  //       }
  //     }
  //   }
  //
  //
  //   if (this.currentChildrenList.length == sortedConfig.length){
  //     let copyArr = this.currentChildrenList.slice();
  //     copyArr.forEach((_item, index)=>{
  //       this.currentChildrenList[index] = this.getItemFromArrByChIdWithRemove(sortedConfig, _item);
  //     })
  //   }
  //
  //
  //   this.currentChildrenList.sort((a,b)=>{
  //     if(a instanceof Group && !(b instanceof Group)){
  //       return -1;
  //     }
  //     if (!(a instanceof Group) && b instanceof Group){
  //       return 1;
  //     }
  //     return 0;
  //   });
  //
  //   this.cd.detectChanges()
  // }

  private getItemFromArrByChIdWithRemove(arr, item){
    let copy = arr.slice();
    for (let i=0; i < copy.length; i++){
      let _item = copy[i];
      if (_item.getCHIId() == item.getCHIId()){
        arr.splice(i, 1);
        return _item;
      }
    }
    return null;
  }

  toggleItemVisibility(e:Event){
    e.stopPropagation();
    e.stopImmediatePropagation();
    this.gs.setGroupItemsVisibility(this.item, !this.isItemsVisible);
  }

  isItem(item){
    return item instanceof Item;
  }

  isGroupElementVisible(){
    if (!this.item.getParentGroupId()){
      return true;
    }
    if (this.isMouseOnElement){
      return true;
    }

    return this.isAdditionalBlockVisible && this.gsDOM.activeGroupVal.getId() == this.item.getId();
  }

  isEmptyGroup() {
    if (!this.hasChildren) {
      return true;
    }
    else {
      for (let i = 0; i < this.currentChildrenList.length; i++) {
        const childrenListElement = this.currentChildrenList[i];
        if (childrenListElement instanceof Item) {
          return false;
        }
        if (childrenListElement instanceof Group && !childrenListElement.is_empty) {
          return false;
        }
      }
      return true;
    }
  }

  getEyeIcon(){
    return this.item.labelVisibility ? 'eye' : 'eye-slash';
  }
  getLockIcon(){
    return this.item.objectsDrag ? 'unlock' : 'lock';
  }

  toggleFolderLabels(event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    this.item.labelVisibility = !this.item.labelVisibility;
    this.gs.setGroupLabelsVisibility(this.item);
    this.cd.detectChanges();
  }

  toggleObjectsUnlock(event, _item) {
    event.stopImmediatePropagation();
    event.stopPropagation();

    let item = this.item;
    if (_item){
      item = _item;
    }

    item.objectsDrag = !item.objectsDrag;
    item.items.forEach((__item)=>{
      const isToolDragged = __item.config.getTool() && __item.config.getTool().is_draggable;
      clearTimeout(__item.timer);
      if (isToolDragged) {
        __item.drag_enabled = item.objectsDrag;
      }
      else{
        __item.drag_enabled = false;
      }
    });
    if (item.subgroups){
      item.subgroups.forEach((__subgroup)=>{
        this.toggleObjectsUnlock(event, __subgroup);
      })
    }
    this.cd.detectChanges();
  }

  setSelectedForDrop(flag, event){
    if (this.draggableElement) {
      if (flag && this.groupElement.nativeElement.contains(event.target)) {
        this.isEventInside = true;
        this.isMouseEnter = true;
        this.openDelayObservable$.pipe( throttle(config => interval(500).pipe(filter(val => !this.isOpened && this.isMouseEnter)), {trailing: true, leading: false})).subscribe(()=>{
          this.isOpened = true;
          this.gs.openedGroups.set(this.item.getId(), this.item);
          this.cd.detectChanges();
        });
      }

      if (this.isEventInside && !flag && !this.groupElement.nativeElement.contains(event.relatedTarget)) {
        this.isEventInside = false;
        this.isMouseEnter = false;
      }

      this.cd.detectChanges();
    }
  }

  onDrop(event: { nativeElement: DragEvent, dragData: Item } | any) {
    if (this.item instanceof Group) {
      if (Array.isArray(this.draggableElement)) {
        this.draggableElement.forEach((item) => {
          if (item.config.getGroupId() !== this.item.getId()) {
            this.moveToNewFolder(item);
          }
        });
      } else {
        const item = event.dragData;
        if (item.config.getGroupId() !== this.item.getId()) {
          this.moveToNewFolder(item);
        }
      }
    }
    this.ds.onDrop$ = event;
  }

  private moveToNewFolder(item: Item): void {
    const isArray = ObjectArrayPlugin.isItemHasObjectArray(item);
    if (isArray) {
      const arrayPlugin = item.registeredPlugins.find(plug => plug instanceof ObjectArrayPlugin);
      const copies = arrayPlugin.getCopies();
      copies.forEach(copy => this.gs.moveToNewGroup(copy, this.item));
    }

    this.gs.moveToNewGroup(item, this.item);
  }

  setMouseOnElement(value:boolean){
    this.isMouseOnElement = value;
  }

  toggleOpenStatus(){
    this.isOpened = !this.isOpened;
    if (this.isOpened){
      this.gs.openedGroups.set(this.item.getId(), this.item);
    }
    else{
      if (this.gs.openedGroups.has(this.item.getId())){
        this.gs.openedGroups.delete(this.item.getId());
      }
    }
    this.cd.detectChanges();
  }


  public changeGroupVisibility(event){
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  updateTitle(event) {
    const prevConfig = Object.assign({}, this.item);
    this.item.setTitle(event);
    this.gs.updateGroup(this.item, prevConfig);
  }

  preventEvents(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

}
